module.exports = __webpack_public_path__ + "258b167f.svg";